export class AlreadyLinkedToOtherAuthProviderException extends Error {
  constructor() {
    super('This account is already linked to another authentication provider');
  }
}
